import { Action, createReducer, on } from "@ngrx/store";
import { CheckoutActions } from "../actions";
import { CheckoutCountriesState } from "../checkout.state";

const initialState: CheckoutCountriesState = {
    loading: null,
    success: null,
    error: null,
    countriesData: [],
    regionData: []
};

const checkoutCountriesReducer = createReducer(
    initialState,
    on(
        CheckoutActions.loadCountries,
        (state: CheckoutCountriesState) => ({
            ...state,
            loading: true,
            success: null,
            error: null,
        })
    ),
    on(
        CheckoutActions.loadCountriesSuccess,
        (state: CheckoutCountriesState, { payload }) => ({
            ...state,
            loading: null,
            success: true,
            error: null,
            countriesData: payload
        })
    ),
    on(
        CheckoutActions.loadCountriesFail,
        (state: CheckoutCountriesState, { payload }) => ({
            ...state,
            loading: null,
            success: null,
            error: payload
        })
    ),
    on(
        CheckoutActions.loadRegionSuccess,
        (state: CheckoutCountriesState, { payload }) => ({
            ...state,
            loading: null,
            success: true,
            error: null,
            regionData: payload
        })
    ),
    on(
        CheckoutActions.loadRegionFail,
        (state: CheckoutCountriesState, { payload }) => ({
            ...state,
            loading: null,
            success: null,
            error: payload
        })
    ),
    on(
        CheckoutActions.clearCheckoutState,
        () => ({ ...initialState })
    )
);

export function reducer(state: CheckoutCountriesState | undefined, action: Action) {
    return checkoutCountriesReducer(state, action);
}